import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

type AlertKind = 'success' | 'error' | 'info' | 'warning';

/**
 * Snackbar/toast standard dell'app.
 *
 * Colori semantici coerenti (classi in `styles.scss`: success=verde, error=rosso,
 * warning=giallo, info=neutro), durate di default per tipo (gli errori restano
 * più a lungo) e action label unica. Usare al posto di `MatSnackBar.open(...)`
 * sparso nei componenti.
 */
@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private readonly durations: Record<AlertKind, number> = {
    success: 3000,
    info: 3000,
    warning: 4000,
    error: 5000,
  };

  /** @deprecated mantenuto per retro-compatibilità. */
  defaultDuration = 3000;

  constructor(private _snackBar: MatSnackBar) {}

  success(message: string, config?: MatSnackBarConfig) {
    this.show(message, 'success', config);
  }

  error(message: string, config?: MatSnackBarConfig) {
    this.show(message, 'error', config);
  }

  info(message: string, config?: MatSnackBarConfig) {
    this.show(message, 'info', config);
  }

  warning(message: string, config?: MatSnackBarConfig) {
    this.show(message, 'warning', config);
  }

  private show(message: string, kind: AlertKind, config?: MatSnackBarConfig) {
    this._snackBar.open(message, 'Close', {
      duration: this.durations[kind],
      panelClass: kind,
      ...config,
    });
  }
}
